const lastSunday = (month: number) => {
  var date = new Date(new Date().getFullYear(), month, 1, 12);
  let weekday = date.getDay();
  let dayDiff = weekday === 0 ? 7 : weekday;
  date.setDate(date.getDate() - dayDiff);
  let day = date.getDate();
  return day < 9 ? "0" + day : day;
};

//We check if the race date is between the summer time so we have to decrease 1 hour
const transformHour = (date: string): string => {
  const originalDate = new Date(date); // crea objeto Date desde string ISO
  const year = originalDate.getFullYear();

  // Obtener últimos domingos de marzo y octubre (inicio y fin del horario de verano)
  const summerStart = lastSundayOfMonth(year, 2); // marzo: mes 2 (0 indexado)
  const summerEnd = lastSundayOfMonth(year, 9); // octubre: mes 9

  // Verificamos si está dentro del horario de verano
  if (originalDate > summerStart && originalDate < summerEnd) {
    // Restar 1 hora
    originalDate.setHours(originalDate.getHours() - 1);
  }

  return originalDate.toISOString();
};

// Retorna el último domingo del mes
const lastSundayOfMonth = (year: number, month: number): Date => {
  const lastDay = new Date(year, month + 1, 0); // último día del mes
  const day = lastDay.getDay(); // 0 = domingo, ..., 6 = sábado
  const diff = day === 0 ? 0 : day;
  return new Date(year, month + 1, 0 - diff);
};

export { transformHour };
